import { Component, inject } from '@angular/core';
import { LandCoverService } from '../proxy/planning/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  LandCoverCreateDto,
  LandCoverDto,
  LandCoverExcelDownloadDto,
  LandCoverUpdateDto,
} from '../proxy/planning/dtos/land-cover';
import { LANDCOVER_CONFIG, LANDCOVER_FIELDS } from './land-cover.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-land-cover',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, LandCoverService, ConfirmationService],
  templateUrl: './land-cover.html',
  styleUrl: './land-cover.scss',
})
export class LandCover extends BaseCrudComponent<
  LandCoverDto,
  LandCoverCreateDto,
  LandCoverUpdateDto,
  LandCoverExcelDownloadDto
> {
  service = inject(LandCoverService);
  config = LANDCOVER_CONFIG;
  fields = LANDCOVER_FIELDS;

  protected prepareUpdateDto(data: any, selected: LandCoverDto): LandCoverUpdateDto {
    return {
      name: data.name,
      code: data.code,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'LandCover';
  }
}
